var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { Box, Botao, Form, Alerta, TipoAlerta } from "..";
var Pesquisa = /** @class */ (function (_super) {
    __extends(Pesquisa, _super);
    function Pesquisa() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = React.createRef();
        _this.alerta = React.createRef();
        _this.pesquisar = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, erro_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 8]);
                        return [4 /*yield*/, this.form.current.validar()];
                    case 1:
                        _a.sent();
                        if (!this.form.current.isValido()) return [3 /*break*/, 5];
                        if (!this.props.service) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.service["Pesquisar"](this.props.dados)];
                    case 2:
                        result = _a.sent();
                        this.props.contexto.setState({
                            resultadoPesquisa: result,
                            pesquisado: true
                        });
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.props.onPesquisar()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        erro_1 = _a.sent();
                        if (erro_1.response) {
                            this.alerta.current.adicionarErro(erro_1.response.data);
                            this.form.current.setState({ valido: false });
                        }
                        else {
                            this.alerta.current.adicionarErro(erro_1);
                            this.form.current.setState({ valido: false });
                        }
                        return [4 /*yield*/, this.props.contexto.setState({
                                resultadoPesquisa: []
                            })];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Pesquisa.prototype.render = function () {
        return (React.createElement(Box, { titulo: "Pesquisa" },
            React.createElement(Form, { ref: this.form },
                this.props.children,
                React.createElement(Alerta, { ref: this.alerta, tipo: TipoAlerta.danger, padraoFormulario: true }),
                React.createElement(Botao, { titulo: "Pesquisar", onClick: this.pesquisar }))));
    };
    return Pesquisa;
}(React.Component));
export { Pesquisa };
